import { render, staticRenderFns } from "./design_index.vue?vue&type=template&id=80848a40&scoped=true"
import script from "./design_index.vue?vue&type=script&lang=js"
export * from "./design_index.vue?vue&type=script&lang=js"
import style0 from "./design_index.vue?vue&type=style&index=0&id=80848a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80848a40",
  null
  
)

export default component.exports